import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Abstract3DShapes } from "@/components/decorative";
import { posthog } from "@/lib/posthog";
import { Sparkles } from "lucide-react";

export const FinalCTA = () => {
  const { t } = useTranslation();

  const scrollToForm = () => {
    const formElement = document.getElementById("waitlist-form");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }

    // GTM event
    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: "cta_click",
        cta_location: "final",
      });
    }

    // PostHog event
    if (posthog.__loaded) {
      posthog.capture('cta_clicked', {
        location: 'final',
        button_text: 'Join the Waitlist',
      });
    }
  };

  return (
    <section className="relative py-12 md:py-16 px-4 bg-gradient-to-br from-brand-teal/80 via-brand-purple/80 to-brand-teal/80 text-white overflow-hidden">
      {/* Decorative 3D shapes */}
      <Abstract3DShapes density="sparse" />

      <div className="container mx-auto max-w-4xl text-center relative z-10">
        <h2 className="font-clash text-3xl xs:text-4xl md:text-5xl font-bold mb-6 tracking-tight">
          {t("finalCta.headline")}
        </h2>

        <p className="text-base md:text-lg mb-8 opacity-90 leading-relaxed tracking-wide font-medium">
          {t("finalCta.subtext")}
        </p>

        <Button
          onClick={scrollToForm}
          size="lg"
          className="bg-white text-brand-purple hover:bg-white/90 font-bold shadow-2xl group"
        >
          <Sparkles className="mr-2 w-5 h-5 transition-transform group-hover:rotate-12" />
          {t("finalCta.cta")}
        </Button>

        <div className="mt-6">
          <p className="text-sm opacity-75">
            {t("hero.secondary")}
          </p>
        </div>
      </div>
    </section>
  );
};
